import React from 'react';
import { Helmet } from 'react-helmet';

// Regions Page Component
const RegionsPage = () => {
  const regions = [
    { country: 'Canada', code: 'CAN', creditsPerSms: 1, areaCode: '+1', serviceActive: 'Yes' },
    { country: 'United States of America', code: 'USA', creditsPerSms: 1, areaCode: '+1', serviceActive: 'Yes' },
    { country: 'China', code: 'CHN', creditsPerSms: 2, areaCode: '+86', serviceActive: 'No' },
    { country: 'Liechtenstein', code: 'LIE', creditsPerSms: 2, areaCode: '+423', serviceActive: 'No' },
    { country: 'Thailand', code: 'THA', creditsPerSms: 2, areaCode: '+66', serviceActive: 'Yes' },
    { country: 'Turkey', code: 'TUR', creditsPerSms: 2, areaCode: '+90', serviceActive: 'No' },
    { country: 'Australia', code: 'AUS', creditsPerSms: 3, areaCode: '+61', serviceActive: 'Yes' },
    { country: 'Brazil', code: 'BRA', creditsPerSms: 3, areaCode: '+55', serviceActive: 'No' },
    { country: 'Bahamas', code: 'BHS', creditsPerSms: 3, areaCode: '+1-242', serviceActive: 'No' },
    { country: 'Colombia', code: 'COL', creditsPerSms: 3, areaCode: '+57', serviceActive: 'No' },
    { country: 'Costa Rica', code: 'CRI', creditsPerSms: 3, areaCode: '+506', serviceActive: 'No' },
    { country: 'Denmark', code: 'DNK', creditsPerSms: 3, areaCode: '+45', serviceActive: 'Yes' },
    { country: 'United Kingdom', code: 'GBR', creditsPerSms: 3, areaCode: '+44', serviceActive: 'Yes' },
    { country: 'Poland', code: 'POL', creditsPerSms: 3, areaCode: '+48', serviceActive: 'Yes' },
    { country: 'Puerto Rico', code: 'PRI', creditsPerSms: 3, areaCode: '+1-787', serviceActive: 'No' },
    { country: 'Portugal', code: 'PRT', creditsPerSms: 3, areaCode: '+351', serviceActive: 'Yes' },
    { country: 'Singapore', code: 'SGP', creditsPerSms: 3, areaCode: '+65', serviceActive: 'No' },
    { country: 'Taiwan', code: 'TWN', creditsPerSms: 3, areaCode: '+886', serviceActive: 'No' },
    { country: 'Switzerland', code: 'CHE', creditsPerSms: 4, areaCode: '+41', serviceActive: 'No' },
    { country: 'Chile', code: 'CHL', creditsPerSms: 4, areaCode: '+56', serviceActive: 'No' },
    { country: 'France', code: 'FRA', creditsPerSms: 4, areaCode: '+33', serviceActive: 'No' },
    { country: 'Greece', code: 'GRC', creditsPerSms: 4, areaCode: '+30', serviceActive: 'No' },
    { country: 'Hong Kong', code: 'HKG', creditsPerSms: 4, areaCode: '+852', serviceActive: 'No' },
    { country: 'Ireland', code: 'IRL', creditsPerSms: 4, areaCode: '+353', serviceActive: 'Yes' },
    { country: 'Iceland', code: 'ISL', creditsPerSms: 4, areaCode: '+354', serviceActive: 'No' },
    { country: 'Luxembourg', code: 'LUX', creditsPerSms: 4, areaCode: '+352', serviceActive: 'Yes' },
    { country: 'Latvia', code: 'LVA', creditsPerSms: 4, areaCode: '+371', serviceActive: 'No' },
    { country: 'Norway', code: 'NOR', creditsPerSms: 4, areaCode: '+47', serviceActive: 'No' },
    { country: 'Romania', code: 'ROU', creditsPerSms: 4, areaCode: '+40', serviceActive: 'No' },
    { country: 'South Africa', code: 'ZAF', creditsPerSms: 4, areaCode: '+27', serviceActive: 'No' },
    { country: 'Argentina', code: 'ARG', creditsPerSms: 5, areaCode: '+54', serviceActive: 'No' },
    { country: 'Austria', code: 'AUT', creditsPerSms: 5, areaCode: '+43', serviceActive: 'No' },
    { country: 'Cyprus', code: 'CYP', creditsPerSms: 5, areaCode: '+357', serviceActive: 'No' },
    { country: 'Germany', code: 'DEU', creditsPerSms: 5, areaCode: '+49', serviceActive: 'Yes' },
    { country: 'Spain', code: 'ESP', creditsPerSms: 5, areaCode: '+34', serviceActive: 'Yes' },
    { country: 'Finland', code: 'FIN', creditsPerSms: 5, areaCode: '+358', serviceActive: 'No' },
    { country: 'Hungary', code: 'HUN', creditsPerSms: 5, areaCode: '+36', serviceActive: 'No' },
    { country: 'India', code: 'IND', creditsPerSms: 5, areaCode: '+91', serviceActive: 'Yes' },
    { country: 'Italy', code: 'ITA', creditsPerSms: 5, areaCode: '+39', serviceActive: 'Yes' },
    { country: 'Japan', code: 'JPN', creditsPerSms: 5, areaCode: '+81', serviceActive: 'No' }
  ].sort((a, b) => a.country.localeCompare(b.country));

  return (
    <div style={containerStyle}>
      <Helmet>
        <title>Regions & Credit Pricing | SMS Textr</title>
        <meta name="description" content="Explore SMS Textr's regions and credit pricing for sending SMS. View SMS pricing, supported countries, and more." />
        <meta name="keywords" content="SMS Textr, SMS API, SMS Pricing, Global SMS Service" />
        <meta name="author" content="SMS Textr Team" />
      </Helmet>
      <section style={sectionStyle}>
        <h1>SMS Textr Regions and Credit Pricing</h1>
      </section>

      <section style={tableSectionStyle}>
        <table style={tableStyle}>
          <thead>
            <tr style={headerRowStyle}>
              <th style={headerCellStyle}>Country</th>
              <th style={headerCellStyle}>Code</th>
              <th style={headerCellStyle}>Credits Used Per SMS</th>
              <th style={headerCellStyle}>Area Code</th>
              <th style={headerCellStyle}>Service Active</th>
            </tr>
          </thead>
          <tbody>
            {regions.map((region, index) => (
              <tr key={index} style={{ ...rowStyle, ...(region.serviceActive === 'Yes' ? activeRowStyle : {}) }}>
                <td style={cellStyle}>{region.country}</td>
                <td style={cellStyle}>{region.code}</td>
                <td style={cellStyle}>{region.creditsPerSms}</td>
                <td style={cellStyle}>{region.areaCode}</td>
                <td style={cellStyle}>{region.serviceActive}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
};

// Inline CSS for styling
const containerStyle = {
  padding: '20px',
  fontFamily: 'Arial, sans-serif',
  backgroundColor: '#f4f4f9',
};

const sectionStyle = {
  color: '#28a745', // Changed text color to #28a745
  padding: '10px',
  marginBottom: '50px',
  textAlign: 'center',
};

const tableSectionStyle = {
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  marginTop: '20px',
};

// New styles for modern look
const headerRowStyle = {
  backgroundColor: '#28a745', // Header background color
  color: '#fff', // Header text color
};

const headerCellStyle = {
  padding: '12px', // Padding for header cells
  textAlign: 'center', // Align text to the left
};

const rowStyle = {
  borderBottom: '1px solid #ddd', // Bottom border for rows
  transition: 'background-color 0.3s', // Transition for hover effect
};

const cellStyle = {
  padding: '12px', // Padding for cells
  textAlign: 'center', // Align text to the left
};

// Add hover effect for rows
const rowHoverStyle = {
  backgroundColor: '#f1f1f1', // Background color on hover
};

// New style for active service rows
const activeRowStyle = {
  backgroundColor: '#d4edda', // Light green background for active services
};

export default RegionsPage;
